import { h } from 'preact'
import { htmlEncodeByRegExp } from 'scripts/utils'
import cls from 'classnames'
import classes from './index.scss'

interface Props {
  content?: string
  className?: string
}

const FieldDescription = ({ content, className }: Props) => {
  if (!content) {
    return null
  }
  const html = htmlEncodeByRegExp(content)
  return <div className={cls(classes.fieldDesc, className)} dangerouslySetInnerHTML={{ __html: html }} />
}

export default FieldDescription
